import React from "react";

import colors from "core/colors";

const AngleDownSvg = () => {
    return (
        <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="arrow-down"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 2.59692L1.264 1.33332L4.0008 4.07092L6.7372 1.33452L8 2.59732L4 6.59732L0 2.59692Z"
                fill={colors.fossil}
            />
        </svg>
    );
};

export default AngleDownSvg;
